import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ascii'
})
export class AsciiPipe implements PipeTransform {

  transform(txt: string, toLowerCase: boolean = false): string {
    return AsciiPipe.transform(txt, toLowerCase);
  }

  public static transform(txt: string, toLowerCase: boolean = false): string {
    if (typeof txt == "undefined" || txt == null) return '';

    txt = txt.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    txt = txt.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
    txt = txt.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    txt = txt.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
    txt = txt.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    txt = txt.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
    txt = txt.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    txt = txt.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
    txt = txt.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    txt = txt.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
    txt = txt.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    txt = txt.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
    txt = txt.replace(/đ/g, 'd');
    txt = txt.replace(/Đ/g, 'D');
    if (toLowerCase) {
      return txt.toLowerCase();
    }
    return txt;
  }
}
